<div class="rd-widget rd-widget-no-height-restriction" style="background-color: white;" *ngIf="widgetData">

  <table aria-hidden="true" class="chart-widget-table-container">
    <tr>
      <td class="chart-table-wrapper" rowspan="2" style="width:60%;">
        <div class="k-donut-chart-container-print-fix column-chart-styling">
          <kendo-chart [title]="titleColumnChart" (render)="onRender($event)" class="k-donut-chart-area" *ngIf="chartsReady" [transitions]="chartTransitionsEnabled">
            <kendo-chart-area background="white" height="300" width="600"></kendo-chart-area>
            <kendo-chart-value-axis>
              <kendo-chart-value-axis-item name="first">
                <kendo-chart-value-axis-item-title font="12px Arial"></kendo-chart-value-axis-item-title>
                <kendo-chart-value-axis-item-labels font="12px Arial"></kendo-chart-value-axis-item-labels>
              </kendo-chart-value-axis-item>
            </kendo-chart-value-axis>
            <kendo-chart-category-axis>
              <kendo-chart-axis-defaults>
                <kendo-chart-axis-defaults-labels format="n0">
                </kendo-chart-axis-defaults-labels>
              </kendo-chart-axis-defaults>
              <kendo-chart-category-axis-item name="categoryAxis" [categories]="categories">
                <kendo-chart-category-axis-item-labels [position]="'start'" font="12px Arial"></kendo-chart-category-axis-item-labels>
              </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>
            <kendo-chart-series>
              <kendo-chart-series-item *ngFor="let item of chartDataColumnChart; let i = index;" type="column" [name]="item.name" [color]="item.color" [stack]="true" [gap]="1"
                                       [data]="item.data" axis="first">
              </kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-legend [visible]="true" [labels]="{color: '#000000', font: '12px Arial'}" position="bottom" orientation="horizontal">
            </kendo-chart-legend>
          </kendo-chart>
        </div>
      </td>
      <td class="chart-table-wrapper">
        <div class="k-donut-chart-container-print-fix first-donut-chart-styling">
          <div class="k-donut-chart-wrapper">
            <kendo-chart [title]="titleDcfCapex" *ngIf="chartsReady" class="k-donut-chart-area" [transitions]="chartTransitionsEnabled">
              <kendo-chart-area background="none"></kendo-chart-area>

              <ng-template kendoChartDonutCenterTemplate>
                <h3 [style.fontSize]="(textScale*30) + 'px'" [style.margin]="'10px'">{{currency}}{{ dcfCapexTotal | number:"1.0-0"}}</h3>
                <h3 [style.fontSize]="(textScale*30) + 'px'" [style.margin]="0">{{ titleTotalCapex.text }}</h3>
              </ng-template>

              <kendo-chart-series>
                <kendo-chart-series-item type="donut" [data]="chartDataDcfCapexBreakdownEntries" categoryField="label" field="value" [color]="color" [size]="(donutHoleScale*20)" [holeSize]="(donutHoleScale*100)" [autoFit]="true">
                  <kendo-chart-series-item-labels [visible]="false">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>

              <kendo-chart-legend [visible]="false"></kendo-chart-legend>
            </kendo-chart>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td class="chart-table-wrapper">
        <div class="k-donut-chart-container-print-fix second-donut-chart-styling">
          <div class="k-donut-chart-wrapper">
            <kendo-chart [title]="titleIncomeCapitalisation" *ngIf="chartsReady" class="k-donut-chart-area" [transitions]="chartTransitionsEnabled">
              <kendo-chart-area background="none"></kendo-chart-area>

              <ng-template kendoChartDonutCenterTemplate>
                <h3 [style.fontSize]="(textScale*30) + 'px'" [style.margin]="'10px'">{{currency}}{{ incomeCapitalisationTotal | number:"1.0-0"}}</h3>
                <h3 [style.fontSize]="(textScale*30) + 'px'" [style.margin]="0">{{ titleTotalCapex.text }}</h3>
              </ng-template>

              <kendo-chart-series>
                <kendo-chart-series-item type="donut" [data]="chartDataIncomeCapitalisationCapexBreakdownEntries" categoryField="label" field="value" [color]="color" [size]="(donutHoleScale*20)" [holeSize]="(donutHoleScale*100)" [autoFit]="true">
                  <kendo-chart-series-item-labels [visible]="false">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>

              <kendo-chart-legend [visible]="true" [labels]="{color: '#000000', font: '12px Arial'}" position="bottom" orientation="horizontal">
              </kendo-chart-legend>
            </kendo-chart>
          </div>
        </div>
      </td>
    </tr>
  </table>

</div>
